const CLARITY_TAG_URL = 'https://www.clarity.ms/tag/';

/**
 * Records a custom Clarity event (used to track onboarding steps). No-ops when
 * Clarity is not initialised.
 */
export function clarityEvent(name) {
    if (typeof window.clarity !== 'function') return;
    window.clarity('event', name);
}

export function initClarity() {
    const projectId =
        process.env.REACT_APP_CLARITY_PROJECT_ID ||
        window._env_?.REACT_APP_CLARITY_PROJECT_ID;

    if (!projectId || window.clarity) return;

    window.clarity = function () {
        (window.clarity.q = window.clarity.q || []).push(arguments);
    };

    const script = document.createElement('script');
    script.async = true;
    script.src = `${CLARITY_TAG_URL}${encodeURIComponent(projectId)}`;
    document.head.appendChild(script);
}
